<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>User ability to book this option</span>
      <div>
        @if (itemCanBeBookedForm.value) {
          <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
          </eas-editor-booking-item-inheritable-type-badge>
        }
      </div>
    </div>
  </legend>
  <p i18n>
    By default users are always booking onto the lowest bookable option set in the hierarchy.
    <br>
    Use this setting to change this behaviour and choose specifically onto which option level you wish users to book.
    <br>
    When this is checked users will not be shown any bookable options beneath this option in the hierarchy.
  </p>
      @if (itemCanBeBookedForm.disabled) {
        <p>
          @if (replacingItem.ancestorCanBeBooked) {
            <ng-container i18n>
      This field is disabled at the moment because an option above is set as bookable.
    </ng-container>
          }
          @if (!replacingItem.ancestorCanBeBooked && replacingItem.children.length === 0) {
            <ng-container i18n>
      This field is disabled at the moment because there are no options beneath.
    </ng-container>
          }
        </p>
      }
      <mat-checkbox id="can-be-booked" [indeterminate]="itemCanBeBookedForm.disabled" formControlName="canBeBooked" i18n>
    Allow users to book onto this option
  </mat-checkbox>
      <p i18n>
    Users are always shown the option name and venue of the bookable option onto which they are initially booking.
    <br>
    It is possible to place them into a different option beneath this level in the hierarchy at a later date.
    <br>
    Use this setting to hide the option name and venue from the option onto which they are placed.
  </p>
          @if (itemHideSpecificBookingSettingsForm.disabled) {
            <p>
              @if (replacingItem.children.length === 0) {
                <ng-container i18n>
      This field is disabled at the moment because there are no options beneath.
    </ng-container>
              }
              @if (replacingItem.children.length > 0 && !replacingItem.canBeBooked) {
                <ng-container i18n>
      This field is disabled at the moment because this option is not set as bookable.
    </ng-container>
              }
            </p>
          }
          <mat-checkbox id="hide-specific-booking-settings" [indeterminate]="itemHideSpecificBookingSettingsForm.disabled" formControlName="hideSpecificBookingSettings" i18n>
    Hide option name and venue when placing user
  </mat-checkbox>
        </fieldset>
